import React from 'react';
import Html from 'react-pdf-html';
import {Text, View, StyleSheet } from '@react-pdf/renderer';
// import { valueIsNull } from '@iso/lib/helpers/utility';

const styles = StyleSheet.create({
    reportTitle:{
        fontSize: 11,
        marginTop: 5,
        fontFamily: 'Helvetica-Bold',
        textIndent:'5px'
    },
    container:{
        paddingTop:'3px',
        paddingLeft:'3px',
        paddingRight:'3px',
        flexDirection: 'row',
        fontWeight:'normal',
        border: '1px solid #000000',
        borderRadius:'3px'
    },
    text:{
        fontSize:10,
        whiteSpace: 'pre-line'
    }
  });

  
  const ProposalComercialCondictions = ({title, value}) => {
      return (typeof value !== 'undefined' && value !== null) ? 
        <>
            <Text style={styles.reportTitle}>{title}</Text>
            <View style={styles.container}>
                <Text><Html style={styles.text}>{value.split('\n').join("<br/>")}</Html></Text>
            </View>
        </> : ''
  }
  
  export default ProposalComercialCondictions